var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 305,
    viewBox: "0 0 333 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.745 105.192H38.4759C36.8006 101.004 34.4552 90.7844 38.4759 83.4131C42.4966 76.0418 55.2289 72.5237 61.0924 71.686C57.4626 69.1731 50.6525 55.1798 61.0924 43.0751C69.7618 33.0233 88.1764 36.2254 96.2737 39.0175C94.8776 34.2708 97.4042 22.6362 107.456 17.9456C120.021 12.0824 127.825 20.8686 133.13 24.7774C135.364 15.0048 147.538 -3.20006 178.363 2.1609C202.948 6.4365 210.752 28.9657 207.681 39.0175C209.915 32.8748 237.292 24.7774 261.29 39.0175C290.148 56.1405 292.563 89.2765 284.745 105.192Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.384 131.025H214.678C208.256 126.558 197.255 114.608 204.627 102.545C211.998 90.4824 235.061 90.2594 245.671 91.6557C253.21 84.3961 262.927 71.2201 281.69 73.2305C300.454 75.2408 310.17 93.3309 307.657 102.545C311.566 101.149 321.227 100.702 328.599 110.084C335.97 119.465 325.527 127.954 319.384 131.025Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.63 209.086L1.70117 152.89L107.783 256.118L106.63 209.086Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.62 182.926L1.70117 152.89L106.63 209.086L136.62 182.926Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.158 255.68L75.5762 235.434L88.6668 222.928C89.8523 221.796 91.8006 222.169 92.4836 223.66L107.158 255.68Z",
    fill: "#D6E4FF",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5087 257.803L1.07617 152.452L90.6496 221.242L51.5087 257.803Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.811 260.026C112.486 271.195 123.71 293.365 155.206 292.695C186.702 292.024 195.692 279.013 196.251 272.591C197.926 266.448 197.591 252.823 182.848 247.462C164.42 240.76 160.315 260.653 162.745 266.728C164.42 270.916 166.933 283.48 201.277 298.558C228.751 310.62 256.282 295.766 266.613 286.831",
    stroke: "black",
    strokeWidth: 2.38571,
    strokeDasharray: "7.16 7.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/Picture.b2015d883204f1b13bbb86dc35bb2620.svg";
export { ForwardRef as ReactComponent };